import EZO_I2C	from "../ezo_i2c.js";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "";
    this.status = "uninitialized";        
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x66);      
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");

      this.usbProductName = "ezo_rtd";
      this.usbSerialNumber = "0x66";   
      this.name = "ezortdSensor";

      this.status = "ok";

    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }  
  async update(devices) {    
    this.value = Math.round(parseFloat(await this.command("R"))*100)/100;
  }
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");          
  }
  async calibrateTo(t) {
    await this.command(`Cal,${t}`);
    this.calibrationStatus = await this.command("Cal,?");        
  }
  async RM_clearCalibration() {
    await this.clearCalibration();
  }
  async RM_calibrateTo(t) {
    await this.calibrateTo(t);
  }  
  toJSON() {
    return({
      name: this.name,  
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,                        
      status: this.status,      
      id: this.id,
      value: this.value,
      calibrationStatus: this.calibrationStatus
    });
  }
}

export default Module;